import React from "react";
import ReactDOM from "react-dom";
import { GlobalProviderWrapper } from "./core/contexts/global";
import Router from "./core/infrastructure/router";
import { worker } from "./core/mocks/api/browser";

if (process.env.REACT_APP_ENABLE_MOCK_SERVER === "true") {
  worker.start();
}

ReactDOM.render(
  <React.StrictMode>
    <GlobalProviderWrapper>
      <Router />
    </GlobalProviderWrapper>
  </React.StrictMode>,
  document.getElementById("root")
);
